/* eslint-disable */

export default class Url {
  static matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/

  /**
   * Loosely validate a URL `string`.
   *
   * @param {String} string
   * @return {Boolean}
   */
  static validate (string) {
    return this.matcher.test(string)
  }
}
